import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Trash2 } from "lucide-react";

export default function AuthorsPanel() {
  const [list, setList] = useState([]);
  const [name, setName] = useState("");
  const [ttl, setTtl] = useState("");
  const [bio, setBio] = useState("");
  const [editingId, setEditingId] = useState(null);
  const load = () => api.get("/authors").then(r => setList(r.data));
  useEffect(() => { load(); }, []);
  const reset = () => { setName(""); setTtl(""); setBio(""); setEditingId(null); };
  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    const body = { name, title: ttl, bio };
    if (editingId) { await api.put(`/authors/${editingId}`, body); toast.success("Author updated"); }
    else { await api.post("/authors", body); toast.success("Author added"); }
    reset(); load();
  };
  const edit = (a) => { setEditingId(a.author_id); setName(a.name); setTtl(a.title || ""); setBio(a.bio || ""); };
  const del = async (id) => { if (!confirm("Delete author?")) return; await api.delete(`/authors/${id}`); load(); };
  return (
    <Card className="border-slate-200 mt-6">
      <CardHeader><CardTitle className="font-heading">Authors {editingId && <button onClick={reset} className="ml-3 text-xs uppercase tracking-widest text-slate-500">Cancel</button>}</CardTitle></CardHeader>
      <CardContent>
        <form onSubmit={submit} className="grid md:grid-cols-3 gap-3 items-end">
          <div><label className="text-xs uppercase tracking-widest text-slate-500">Name</label><Input value={name} onChange={e=>setName(e.target.value)}/></div>
          <div><label className="text-xs uppercase tracking-widest text-slate-500">Title / credentials</label><Input value={ttl} onChange={e=>setTtl(e.target.value)} placeholder="e.g. RN, Hospice Educator"/></div>
          <Button type="submit" className="bg-sky-700 hover:bg-sky-600">{editingId ? "Save" : "Add author"}</Button>
          <div className="md:col-span-3"><label className="text-xs uppercase tracking-widest text-slate-500">Bio</label><Textarea rows={2} value={bio} onChange={e=>setBio(e.target.value)}/></div>
        </form>
        <ul className="mt-6 divide-y divide-slate-200 border-y border-slate-200 text-sm">
          {list.map(a => (
            <li key={a.author_id} className="py-3 flex items-start justify-between gap-4">
              <div className="flex-1">
                <div className="font-heading font-semibold text-slate-900">{a.name}</div>
                {a.title && <div className="text-xs text-slate-500">{a.title}</div>}
                {a.bio && <div className="text-slate-600 text-sm mt-1 line-clamp-2">{a.bio}</div>}
              </div>
              <div className="flex gap-2">
                <button onClick={()=>edit(a)} className="text-sky-700 text-xs uppercase tracking-widest">Edit</button>
                <button onClick={()=>del(a.author_id)} className="text-red-500 hover:text-red-700"><Trash2 className="w-4 h-4"/></button>
              </div>
            </li>
          ))}
          {list.length === 0 && <li className="py-6 text-slate-400 text-center">No authors yet.</li>}
        </ul>
      </CardContent>
    </Card>
  );
}
